import { useMutation, useQuery } from "@tanstack/react-query";
import { useState } from "react";
import {
  addBanner,
  deleteBanner,
  getAllAlbum,
  getBanners,
  getImage,
  getMusic,
  updateBanner,
} from "../utils/api";

import {
  Button,
  Form,
  Image,
  Input,
  InputNumber,
  Modal,
  Popconfirm,
  Select,
  Switch,
  Table,
  Typography,
  message,
} from "antd";
import BackendUpload from "../components/BackendUpload";

const Banner = () => {
  const { data, isLoading, refetch } = useQuery({
    queryKey: ["banners"],
    queryFn: async () => await getBanners(),
  });

  const { mutate, isPending: isLoading2 } = useMutation({
    mutationFn: async (values) => await deleteBanner(values),
    onSuccess: () => {
      message.success(`Deleted Banner`);
      refetch();
    },
  });
  const { data: albums } = useQuery({
    queryKey: ["albums"],
    queryFn: async () => await getAllAlbum(),
  });

  const { data: music } = useQuery({
    queryKey: ["musics"],
    queryFn: async () => await getMusic(),
  });
  const columns = [
    {
      title: "Actions",
      dataIndex: "action",
      render(value, record) {
        return (
          <div
            style={{
              display: "flex",
              justifyContent: "space-around",

              flexDirection: "column",
              gap: 10,
            }}
          >
            <AddData
              update={record}
              refech={refetch}
              artists={music}
              albums={albums}
            />
            <Popconfirm
              title="Delete the task"
              description="Are you sure to delete this task?"
              okText="Yes"
              cancelText="No"
              onConfirm={() => mutate(record._id)}
            >
              <Button danger loading={isLoading2}>
                Delete
              </Button>
            </Popconfirm>
          </div>
        );
      },
    },

    {
      title: "Image",
      dataIndex: "image",
      render(value) {
        return <Image src={value} width={100} height={100} />;
      },
    },
    {
      title: "Item",
      dataIndex: ["link", "item", "name"],
    },
  ];

  return (
    <div
      style={{
        padding: 24,
      }}
    >
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <Typography style={{ fontSize: 20, fontWeight: 600, marginBottom: 10 }}>
          Banners
        </Typography>
        <AddData refech={refetch} artists={music} albums={albums} />
      </div>
      <Table
        columns={columns}
        dataSource={data}
        loading={isLoading}
        scroll={{ x: 800 }}
      />
    </div>
  );
};

export default Banner;

const AddData = ({ refech, update, artists, albums }) => {
  const [messageApi, contextHolder] = message.useMessage();
  const [visible, setVisible] = useState(false);
  const [form] = Form.useForm();
  const origin = Form.useWatch("origin", form);
  const { mutate, isPending: isLoading } = useMutation({
    mutationFn: async (values) =>
      update
        ? await updateBanner(update?._id, values)
        : await addBanner(values),
    onSuccess: () => {
      messageApi.success(`Added`);
      //reset form
      !update && form.resetFields();
      refech();
      setVisible(false);
    },
    onError: (err) => {
      messageApi.error(err?.response?.data?.message);
    },
  });

  const checked = Form.useWatch("isEnable", form);
  const kind = Form.useWatch(["link", "kind"], form);
  return (
    <div>
      {contextHolder}
      <Button
        type="primary"
        onClick={() => setVisible(true)}
        style={{
          width: "100%",
        }}
      >
        {update ? "Update" : "Add"}
      </Button>
      <Modal
        title={update ? "Edit Banner" : "Add Banner"}
        open={visible}
        onCancel={() => setVisible(false)}
        footer={null}
      >
        <Form
          form={form}
          labelCol={{ span: 8 }}
          layout="horizontal"
          style={{
            maxWidth: 600,
            padding: 20,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
          onFinish={(values) => {
            mutate({
              ...values,

              image: getImage(values?.image) ?? update?.image,
            });
          }}
          initialValues={
            update
              ? {
                  ...update,
                  isEnable: update.isEnable ? true : false,
                  link: {
                    kind: update?.link?.kind,
                    item: update?.link?.item?._id,
                  },
                }
              : {
                  isEnable: true,
                }
          }
        >
          {origin === "Image" ? (
            <BackendUpload
              label={"Banner"}
              type={"photos"}
              name={"image"}
              update={update}
            />
          ) : (
            <Form.Item label="Image" name="image" required>
              <Input />
            </Form.Item>
          )}
          <Form.Item label="Origin" name="origin" required>
            <Select style={{ width: "100%" }}>
              <Select.Option value="Youtube">Youtube</Select.Option>
              <Select.Option value="Video">Video</Select.Option>
              <Select.Option value="Image">Image</Select.Option>
              <Select.Option value="YoutubeLive">YoutubeLive</Select.Option>
              <Select.Option value="Song">Song</Select.Option>
            </Select>
          </Form.Item>
          <Form.Item label="Kind" name={["link", "kind"]} required>
            <Select style={{ width: "100%" }}>
              <Select.Option value="album">Album</Select.Option>
              <Select.Option value="music">Music</Select.Option>
            </Select>
          </Form.Item>
          <Form.Item
            label={kind === "album" ? "Album" : "Artist"}
            name={["link", "item"]}
            required
          >
            <Select style={{ width: "100%" }}>
              {kind === "album" && albums
                ? albums?.map((item) => (
                    <Select.Option key={item._id} value={item._id}>
                      {item.name}
                    </Select.Option>
                  ))
                : artists?.map((item) => (
                    <Select.Option key={item._id} value={item._id}>
                      {item.name}
                    </Select.Option>
                  ))}
            </Select>
          </Form.Item>

          <Form.Item label="Is Enable" name="isEnable">
            <Switch
              checkedChildren="Yes"
              unCheckedChildren="No"
              checked={checked}
            />
          </Form.Item>

          <Form.Item
            label="Position"
            name="position"
            required
            rules={
              !update
                ? [
                    {
                      required: true,
                      message: "Please input your position!",
                    },
                  ]
                : []
            }
          >
            <InputNumber style={{ width: "100%" }} />
          </Form.Item>

          <Button type="primary" htmlType="submit" loading={isLoading}>
            Submit
          </Button>
        </Form>
      </Modal>
    </div>
  );
};
